import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import HomeIcon from '@mui/icons-material/Home';
import { Box, Button, Typography } from '@mui/material';
import WarningIcon from '../../assets/images/warning-icon.svg';
export var NaoEncontradoPage = function () {
    var handleHomeRedirect = function () {
        window.location.href = process.env.REACT_APP_URL_PROJETO || '/';
    };
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            textAlign: 'center',
            px: 3,
        }, children: [_jsx("img", { src: WarningIcon, alt: "Aten\u00E7\u00E3o", style: {
                    width: 80,
                    height: 80,
                    marginBottom: 16,
                } }), _jsx(Typography, { variant: "h5", mb: 2, align: "center", children: "P\u00E1gina n\u00E3o encontrada" }), _jsx(Typography, { variant: "body1", color: "textSecondary", mb: 3, align: "center", children: "O recurso solicitado n\u00E3o foi encontrado. Verifique o endere\u00E7o ou volte para a p\u00E1gina inicial." }), _jsx(Button, { variant: "outlined", color: "primary", startIcon: _jsx(HomeIcon, {}), onClick: handleHomeRedirect, sx: { mt: 3 }, children: "P\u00E1gina inicial" })] }));
};
